import React, { useEffect, useState } from 'react';
import OutletHead from '../../../../components/common/outlet-head';
import PartyForm from '../../../../components/forms/party-form';
import { Button } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoArrowBackOutline, IoSettingsOutline } from 'react-icons/io5';
import { doc, updateDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { db, storage } from '../../../../firebase';

function EditAssociate() {

  const location = useLocation();
  let navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [partyID, setPartyID] = useState(null);
  const [imageSource, setImageSource] = useState('');
  const [partyData, setPartyData] = useState({
    partyName: '',
    fatherHusband: '',
    gender: '',
    dob: '',
    occupation: '',
    panNumber: '',
    aadharNumber: '',
    phoneNumber: '',
    alternatePhoneNumber: '',
    email: '',
    address: '',
    city: '',
    pincode: '',
    state: '',
    photo: ''
  });
  const [inputError, setInputError] = useState(null);

  const fireUpdateData = async (id, data) => {
    delete data.updated_on;
    delete data.id;
    data = { updated_on: new Date(), ...data };
    try {
      await updateDoc(doc(db, "Parties", id), data);
      setIsLoading(false);
      navigate(-1);
    } catch (error) {
      console.log('Adding Parties Data [Error] : ', error);
      setIsLoading(false);
    }
  }

  const fireUpdateDataWithPhoto = async (id, data, imageObj) => {
    const storageRef = ref(storage, `/Parties/${id}`);

    const uploadTask = uploadBytesResumable(storageRef, imageObj);

    uploadTask.on("state_changed", (snapshot) => {
      const percent = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      );
      console.log(percent);
    }, (err) => console.log('Parties Photo Uploading [Error] :', err),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          var tempData = { ...data }
          tempData.photo = url;
          fireUpdateData(id, tempData);
        });
      }
    );
  }

  useEffect(() => {
    if (location.state) {
      var tempData = { ...location.state };
      setPartyID(tempData.id);
      delete tempData.id;
      setPartyData(tempData);
    }
  }, [location]);

  function validateAndPostData() {
    const { partyName, fatherHusband, gender, dob, occupation, aadharNumber, phoneNumber, address, city, pincode, state } = partyData;
    if (!partyName) {
      setInputError({ ...inputError, partyName: 'This field is required.' });
    } else if (!fatherHusband) {
      setInputError({ ...inputError, fatherHusband: 'This field is required.' });
    } else if (!gender) {
      setInputError({ ...inputError, gender: 'This field is required.' });
    } else if (!dob) {
      setInputError({ ...inputError, dob: 'This field is required.' });
    } else if (!occupation) {
      setInputError({ ...inputError, occupation: 'This field is required.' });
    } else if (!aadharNumber) {
      setInputError({ ...inputError, aadharNumber: 'This field is required.' });
    } else if (!phoneNumber) {
      setInputError({ ...inputError, phoneNumber: 'This field is required.' });
    } else if (!address) {
      setInputError({ ...inputError, address: 'This field is required.' });
    } else if (!pincode) {
      setInputError({ ...inputError, pincode: 'This field is required.' });
    } else if (!city) {
      setInputError({ ...inputError, city: 'This field is required.' });
    } else if (!state) {
      setInputError({ ...inputError, state: 'This field is required.' });
    } else {
      setIsLoading(true);
      if (imageSource) {
        fireUpdateDataWithPhoto(partyID, partyData, imageSource);
      } else {
        fireUpdateData(partyID, partyData);
      }
    }
  }

  return (
    <section className='section'>
      <OutletHead
        left={
          <div className='d-flex align-items-center'>
            <Button
              variant='light'
              size='sm'
              className='p-2 me-3 rounded-circle'
              onClick={() => navigate(-1)}
            >
              <IoArrowBackOutline size={24} />
            </Button>
            <h5 className='mb-0'>Edit Associate</h5>
          </div>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="light"
              className='border py-2 px-4 me-3'
            >
              <IoSettingsOutline size={20} />
              <span className='ps-2'>Settings</span>
            </Button>
            <Button
              variant="primary"
              className='py-2 px-5'
              onClick={validateAndPostData}
            >
              Update
            </Button>
          </div>
        }
      />
      <div className='px-3 border-top'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='mb-5 position-relative'>
              {
                isLoading ?
                  <div className='loader'>
                    <div className='spinner' />
                  </div>
                  :
                  null
              }
              <PartyForm
                data={partyData}
                setData={setPartyData}
                imageSource={imageSource}
                setImageSource={setImageSource}
                inputError={inputError}
                setInputError={setInputError}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EditAssociate;
